import { render } from "./OverlayRoomConfirm.vue?vue&type=template&id=552e80f9&scoped=true"
import script from "./OverlayRoomConfirm.vue?vue&type=script&lang=js"
export * from "./OverlayRoomConfirm.vue?vue&type=script&lang=js"

import "./OverlayRoomConfirm.vue?vue&type=style&index=0&id=552e80f9&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552e80f9"]])

export default __exports__